import api from "./api";

// Espelha o enum EscopoCategoria do backend (Core/Enums/Enums.cs).
export const ESCOPO_CATEGORIA = {
  Receita: 0,
  Despesa: 1,
  Ambas: 2,
};

export const ESCOPO_LABEL = {
  0: "Receita",
  1: "Despesa",
  2: "Ambas",
};

export async function listCategorias() {
  // GET /api/Categorias — primeira chamada dispara lazy-seed das 11
  // categorias de sistema (TenantDefaultsService no backend).
  const { data } = await api.get("/Categorias");
  return data;
}

export async function createCategoria({ nome, escopo }) {
  const { data } = await api.post("/Categorias", { nome, escopo });
  return data;
}

export async function updateCategoria(id, { nome, escopo }) {
  // NomeSistema e IsSistema são imutáveis no backend — só Nome+Escopo viajam.
  await api.put(`/Categorias/${id}`, { nome, escopo });
}

export async function deleteCategoria(id) {
  // Pode retornar 400 (IsSistema) ou 409 (em uso por lançamentos). O caller
  // captura err.response.data.message pra mostrar mensagem amigável.
  await api.delete(`/Categorias/${id}`);
}

// Filtra categorias visíveis pelo tipo do lançamento (Receita=0, Despesa=1
// no enum TipoFinanceiro do backend). Categorias com Escopo=Ambas aparecem
// em ambos os tipos. Usado pelo FinanceiroFormModal.
export function filtrarPorTipoFinanceiro(categorias, tipoFinanceiro) {
  return categorias.filter(
    (c) =>
      c.escopo === ESCOPO_CATEGORIA.Ambas ||
      (tipoFinanceiro === 0 && c.escopo === ESCOPO_CATEGORIA.Receita) ||
      (tipoFinanceiro === 1 && c.escopo === ESCOPO_CATEGORIA.Despesa)
  );
}
